module.exports = __webpack_public_path__ + "assets/close-circle-filled-2-12de69.svg";